.loading__container {
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
}

.loading__container__global {
  position: absolute;

  z-index: var(--z-index-important);
  top: 0;
  left: 0;
  background-color: rgb(255, 255, 255, 0.7); // --color-white with opacity
}